export default __webpack_public_path__ + "static/media/icon-etherscan-mono.5820a6be.svg";